import React from "react"
import Help from "./svgs/Help"
import useTheme from "../hooks/useTheme"

interface HelpToolTipProps {
  children: React.ReactNode
  className?: string
}

const HelpToolTip: React.FC<HelpToolTipProps> = ({ children, className }) => {
  const { darkMode } = useTheme()
  return (
    <div
      className={`relative inline-flex group cursor-pointer ${className ?? ""}`}
    >
      <span className="bg-black/10 p-0.5 rounded-full">
        <Help />
      </span>
      <div
        className={`absolute hidden group-hover:block top-0 left-1/2 -translate-y-full -translate-x-1/2 -mt-1 py-2 px-3 rounded-lg border ${
          darkMode
            ? "border-[#202835] bg-[#131823]"
            : "border-[#e3e7ee] bg-[#f3f5fa]"
        }`}
      >
        {children}
      </div>
    </div>
  )
}

export default HelpToolTip
